// semeia-disable-reexport
// Decoding properly base64 -> UTF8
// The pre-2018 solution (functional, and though likely better support for older browsers, not up to date)
// See https://stackoverflow.com/a/30106551
export function b64DecodeUnicode(str: string) {
  return decodeURIComponent(
    Array.prototype.map
      .call(window.atob(str), c => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function b64EncodeUnicode(str: string) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return window.btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function toSolidBytes(_match, p1) {
        return String.fromCharCode(parseInt("0x" + p1));
      }
    )
  );
}
